import React from 'react';
import { motion } from 'framer-motion';

const AuthLayout = ({ children }) => {
    return (
        <div className="fixed inset-0 flex bg-[#FAF9F6] overflow-auto">
            {/* Left Side - Decorative */}
            <div className="hidden lg:flex lg:w-1/2 relative p-12">
                <div className="relative w-full flex flex-col justify-between">
                    {/* Main Content */}
                    <motion.div 
                        className="space-y-8 mt-12"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <h1 className="text-[42px] leading-tight font-bold text-gray-900 tracking-[-0.02em]">
                            Transform Your<br />Learning Experience
                        </h1>
                        <p className="text-gray-600 text-lg leading-relaxed max-w-md">
                            Organize lectures, generate study materials, and enhance your academic journey with AI-powered tools.
                        </p>
                        
                        {/* Feature Pills with staggered animation */}
                        <div className="flex flex-wrap gap-3">
                            {[
                                { text: 'AI Study Tools', color: 'bg-blue-50 text-blue-700' },
                                { text: 'Smart Notes', color: 'bg-green-50 text-green-700' },
                                { text: 'Lecture Analysis', color: 'bg-purple-50 text-purple-700' }
                            ].map((feature, index) => (
                                <motion.span 
                                    key={feature.text}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4, delay: 0.2 + (index * 0.1) }}
                                    className={`px-4 py-2 rounded-full text-sm font-medium ${feature.color}`}
                                >
                                    {feature.text}
                                </motion.span>
                            ))}
                        </div>
                    </motion.div>

                    {/* Footer Text */}
                    <motion.p 
                        className="text-sm text-gray-500 mt-auto"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.6, delay: 0.6 }}
                    >
                        Built with ❤️ for students, by students
                    </motion.p>
                </div>
            </div>

            {/* Right Side - Auth Form */}
            <motion.div 
                className="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-8"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <div className="w-full max-w-md mx-auto">
                    {children}
                </div>
            </motion.div>
        </div>
    );
};

export default AuthLayout;